import { EVENT_LIST } from '@constants/routes';
import type { MagicSearchVenue, MagicSearchVenueCompany } from '@domain/magic-search';
import { VIEW_UPCOMING } from '@hooks/use-event-navigation/use-event-navigation';
import type { CompanyClubRoute } from '@hooks/use-open-company-club-route';

export const getVenueRoute = (venue: MagicSearchVenue, company: MagicSearchVenueCompany): CompanyClubRoute => {
  const companyLegacyId = String(company.legacyId);

  return {
    companyLegacyId,
    clubSlug: venue.slug,
    path: EVENT_LIST.replace(':companyId', companyLegacyId)
      .replace(':clubSlug', venue.slug)
      .replace(':view', VIEW_UPCOMING),
  };
};
